import { useQuery } from '@apollo/client'

import {
  ListConnectionDoorsDocument,
  OrderBillingShippingDocument,
  OrderBillingShippingQuery,
} from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

import { useOrdersQuery } from 'features/Orders/orders.hooks'

atlas`#graphql
  query OrderBillingShipping($filters: OrderFilterInput!) {
    orders(filters: $filters) {
      edges {
        node {
          id
          billing {
            address {
              sourceBillingAddress {
                id
                code
              }
              name
              company
              firstAddress
              secondAddress
              country
              state
              city
              zip
              phone
            }
          }
          shipping {
            ...OrderShippingDetails
          }
          tax {
            ...OrderTax
          }
          doors {
            edges {
              node {
                id
                name
                code
              }
            }
          }
          trackingNumber
          paymentMethod {
            id
            name
            code
          }
        }
      }
    }
  }
`
export type OrderBillingShippingData =
  OrderBillingShippingQuery['orders']['edges'][0]['node']

export const useOrderBillingShipping = () => {
  const { data, loading } = useOrdersQuery(
    OrderBillingShippingDocument,
    {},
    { errorPolicy: 'all' },
  )

  const orderBillingShippingData: OrderBillingShippingData | undefined = (
    data as OrderBillingShippingQuery
  )?.orders.edges[0]?.node

  return { orderBillingShippingData, loading }
}

export const useListConnectionDoors = ({
  retailerId = '',
  isBrand,
}: {
  retailerId?: string
  isBrand: boolean
}) => {
  const { data, loading } = useQuery(ListConnectionDoorsDocument, {
    client: atlasClient,
    variables: { input: { retailerId } },
    skip: !retailerId || !isBrand,
  })

  const doors = data?.listConnectionDoors ?? []
  return { doors, loading }
}
